var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"mobile-ai-floating-chip",style:(_vm.chipStyle),attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" AI ")])
}
var staticRenderFns = []

export { render, staticRenderFns }